import { css } from "styled-components";
import { SplideWrapper } from "../../../../../../../structures/others/slider/styled.js";
import { TabsButton, TabsCarousel, TabsCarouselItem, TabsCarouselList, TabsContent, TabsStyled, TabsVerticalWrapper, TabsWrapper } from "../../../../../../../structures/others/tabs/styled.js";
import { FlexMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
const veciSearcherTabsStyles = {
    SearcherTabsTabs: ()=>css`
		${TabsStyled} {
			background-color: ${({ theme  })=>theme.colors.grays.darker};
		}
		${TabsWrapper} {
			background-color: ${({ theme  })=>theme.colors.grays.darker};
		}
		${TabsVerticalWrapper} {
			background-color: ${({ theme  })=>theme.colors.grays.darker};
		}
		${TabsButton} {
			background-color: ${({ theme  })=>theme.colors.grays.darker};

			font-weight: 400;

			&:hover {
				background-color: transparent;
				color: ${({ theme  })=>theme.colors.white.base};
			}

			&.is-active {
				color: ${({ theme  })=>theme.colors.white.base};
				font-weight: 500;
				background-color: ${({ theme  })=>theme.colors.grays.darker};
				border-bottom-color: ${({ theme  })=>theme.colors.white.base};
				border-bottom-width: 4px;
				border-bottom-style: solid;

				&:hover {
					background-color: transparent;
				}
			}

			&:not(.is-active) {
				background-color: ${({ theme  })=>theme.colors.grays.darker};
				font-weight: 400;

				&:hover {
					background-color: transparent;
					color: ${({ theme  })=>theme.colors.white.base};
				}
			}
		}
		${TabsCarousel} {
			background-color: ${({ theme  })=>theme.colors.grays.darker};
		}
		${TabsCarouselItem} {
			background-color: ${({ theme  })=>theme.colors.grays.darker};
		}
		${TabsCarouselList} {
			background-color: ${({ theme  })=>theme.colors.grays.darker};
		}
		${TabsContent} {
			background-color: ${({ theme  })=>theme.colors.grays.darker};

			form > div {
				background-color: ${({ theme  })=>theme.colors.grays.darker};
			}

			&.is-active {
				background-color: ${({ theme  })=>theme.colors.grays.darker};
			}
		}
		${SplideWrapper} {
			.splide__list {
				/* TODO: this will broke the tabs when there are too many tabs, in VECI works becasue we have 3 tabs but keep it in mind */
				${FlexMixin({
            align: 'center',
            justify: 'center'
        })}
			}
		}
	`
};
export default veciSearcherTabsStyles;

//# sourceMappingURL=veci.js.map